import _defineProperty from "/home/runner/work/frontend-starter/frontend-starter/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/frontend-starter/frontend-starter/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/frontend-starter/frontend-starter/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["__scopePopper", "virtualRef"],
    _excluded2 = ["__scopePopper", "side", "sideOffset", "align", "alignOffset", "collisionTolerance", "avoidCollisions"],
    _excluded3 = ["__scopePopper", "offset"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as e from "@radix-ui/react-arrow";
import { Primitive as o } from "@radix-ui/react-primitive";
import { useSize as r } from "@radix-ui/react-use-size";
import { useRect as t } from "@radix-ui/react-use-rect";
import { createContextScope as n } from "@radix-ui/react-context";
import { useComposedRefs as i } from "@radix-ui/react-compose-refs";
import { getPlacementData as p } from "@radix-ui/popper";
import * as s from "react";
import a from "@babel/runtime/helpers/esm/extends";

var _n = n("Popper"),
    _n2 = _slicedToArray(_n, 2),
    c = _n2[0],
    l = _n2[1];

export { l as createPopperScope };

var _c = c("Popper"),
    _c2 = _slicedToArray(_c, 2),
    f = _c2[0],
    d = _c2[1];

export var Popper = function Popper(e) {
  var o = e.__scopePopper,
      r = e.children,
      _s$useState = s.useState(null),
      _s$useState2 = _slicedToArray(_s$useState, 2),
      t = _s$useState2[0],
      n = _s$useState2[1];
  /*#__PURE__*/


  return s.createElement(f, {
    scope: o,
    anchor: t,
    onAnchorChange: n
  }, r);
};
/*#__PURE__*/

export var PopperAnchor = /*#__PURE__*/s.forwardRef(function (e, r) {
  var t = e.__scopePopper,
      n = e.virtualRef,
      p = _objectWithoutProperties(e, _excluded),
      c = d("PopperAnchor", t),
      l = s.useRef(null),
      f = i(r, l);

  return s.useEffect(function () {
    c.onAnchorChange((null == n ? void 0 : n.current) || l.current);
  }), n ? null : /*#__PURE__*/s.createElement(o.div, a({}, p, {
    ref: f
  }));
});
/*#__PURE__*/

var _c3 = c("PopperContent"),
    _c4 = _slicedToArray(_c3, 2),
    u = _c4[0],
    m = _c4[1];

export var PopperContent = /*#__PURE__*/s.forwardRef(function (e, n) {
  var c = e.__scopePopper,
      _e$side = e.side,
      l = _e$side === void 0 ? "bottom" : _e$side,
      f = e.sideOffset,
      _e$align = e.align,
      m = _e$align === void 0 ? "center" : _e$align,
      w = e.alignOffset,
      h = e.collisionTolerance,
      _e$avoidCollisions = e.avoidCollisions,
      x = _e$avoidCollisions === void 0 ? !0 : _e$avoidCollisions,
      v = _objectWithoutProperties(e, _excluded2),
      P = d("PopperContent", c),
      _s$useState3 = s.useState(),
      _s$useState4 = _slicedToArray(_s$useState3, 2),
      A = _s$useState4[0],
      g = _s$useState4[1],
      E = t(P.anchor),
      _s$useState5 = s.useState(null),
      _s$useState6 = _slicedToArray(_s$useState5, 2),
      y = _s$useState6[0],
      C = _s$useState6[1],
      S = r(y),
      _s$useState7 = s.useState(null),
      _s$useState8 = _slicedToArray(_s$useState7, 2),
      R = _s$useState8[0],
      O = _s$useState8[1],
      _ = r(R),
      b = i(n, function (e) {
    return C(e);
  }),
      z = function () {
    var _s$useState9 = s.useState(void 0),
        _s$useState10 = _slicedToArray(_s$useState9, 2),
        e = _s$useState10[0],
        o = _s$useState10[1];

    return s.useEffect(function () {
      var e;

      function r() {
        o({
          width: window.innerWidth,
          height: window.innerHeight
        });
      }

      function t() {
        window.clearTimeout(e), e = window.setTimeout(r, 100);
      }

      return r(), window.addEventListener("resize", t), function () {
        return window.removeEventListener("resize", t);
      };
    }, []), e;
  }(),
      T = z ? DOMRect.fromRect(_objectSpread(_objectSpread({}, z), {}, {
    x: 0,
    y: 0
  })) : void 0,
      _p = p({
    anchorRect: E,
    popperSize: S,
    arrowSize: _,
    arrowOffset: A,
    side: l,
    sideOffset: f,
    align: m,
    alignOffset: w,
    shouldAvoidCollisions: x,
    collisionBoundariesRect: T,
    collisionTolerance: h
  }),
      k = _p.popperStyles,
      L = _p.arrowStyles,
      B = _p.placedSide,
      D = _p.placedAlign,
      H = void 0 !== B;
  /*#__PURE__*/


  return s.createElement("div", {
    style: k,
    "data-radix-popper-content-wrapper": ""
  }, /*#__PURE__*/s.createElement(u, {
    scope: c,
    arrowStyles: L,
    onArrowChange: O,
    onArrowOffsetChange: g
  }, /*#__PURE__*/s.createElement(o.div, a({
    "data-side": B,
    "data-align": D
  }, v, {
    style: _objectSpread(_objectSpread({}, v.style), {}, {
      animation: H ? void 0 : "none"
    }),
    ref: b
  }))));
});
/*#__PURE__*/

export var PopperArrow = /*#__PURE__*/s.forwardRef(function (o, r) {
  var t = o.__scopePopper,
      n = o.offset,
      i = _objectWithoutProperties(o, _excluded3),
      p = m("PopperArrow", t),
      c = p.onArrowOffsetChange;

  return s.useEffect(function () {
    return c(n);
  }, [c, n]), /*#__PURE__*/s.createElement("span", {
    style: _objectSpread(_objectSpread({}, p.arrowStyles), {}, {
      pointerEvents: "none"
    })
  }, /*#__PURE__*/s.createElement("span", {
    ref: p.onArrowChange,
    style: {
      display: "inline-block",
      verticalAlign: "top",
      pointerEvents: "auto"
    }
  }, /*#__PURE__*/s.createElement(e.Root, a({}, i, {
    ref: r,
    style: _objectSpread(_objectSpread({}, i.style), {}, {
      display: "block"
    })
  }))));
});
/*#__PURE__*/

export var Root = Popper;
export var Anchor = PopperAnchor;
export var Content = PopperContent;
export var Arrow = PopperArrow;